export default __webpack_public_path__ + "static/media/icon-pm.e88a65e3639044de32f0162c253ef5be.svg";